import { fetchReportData, fetchReportsData } from "./actions/fetchActions";
import {
  reportsReducer,
  reportReducer,
  createReportReducer,
  updateReportReducer,
  deleteReportReducer,
} from "./reducers/fetchReducers";

const reportReducers = {
  reportsGlobalStore: reportsReducer,
  reportGlobalStore: reportReducer,
  createReportGlobalStore: createReportReducer,
  updateReportGlobalStore: updateReportReducer,
  deleteReportGlobalStore: deleteReportReducer,
};

export { fetchReportData, fetchReportsData, reportReducers };
